import { matchPath } from 'react-router';
import { Link } from 'react-router-dom';

const getBreadcrumbs = (useReactRouter, pathname, routes, ...args) => {
  const matches = [];
  pathname.replace(/\/$/, '').split('/').reduce((previous, current) => {
    const pathSection = `${previous !== '/' ? previous : ''}/${current}`;
    let breadcrumbMatch;
    Object.values(routes).some(({
      label,
      route
    }) => {
      const match = matchPath(pathSection, route ?? '');
      if (match) {
        const title = typeof label === 'string' ? label : label(match.params, ...args);
        const props = useReactRouter ? {
          Component: Link,
          componentProps: {
            to: pathSection,
            className: 'no-underline'
          }
        } : {
          Component: 'a',
          componentProps: {
            href: pathSection,
            className: 'no-underline'
          }
        };
        breadcrumbMatch = {
          title,
          ...props
        };
        matches.push(breadcrumbMatch);
        return true;
      }
      return false;
    });
    return pathSection;
  }, '/');
  return matches;
};

export { getBreadcrumbs };
